import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'phoneNumberTypeTransform'
})
export class PhoneNumberTypeTransformPipe implements PipeTransform {

  transform(value: string, list:(ServerModels.ENESS_REF_PhoneNumberTypesDTO|ServerModels.ENESS_REF_PhoneNumberTypes)[]): string {
    if (!value || !value.length || !list || !list.length)
      return '';

    let phoneNumberType: ServerModels.ENESS_REF_PhoneNumberTypes = list.find((x) => x.PhoneNumberTypeID.toLowerCase() == value.toLowerCase());
    return phoneNumberType.PhoneNumberType;
  }

}
